import { render, staticRenderFns } from "./CreationSettingFormBiddingStrategyField.vue?vue&type=template&id=56809fc4&"
import script from "./CreationSettingFormBiddingStrategyField.vue?vue&type=script&lang=js&"
export * from "./CreationSettingFormBiddingStrategyField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports